// Shared presentation of the existing payment form's calculations.
// Amounts are in currency units; the API remains the financial authority.
export function installmentAmount(total, months) {
    if (!(months > 1)) return total;
    let amount = total / months;
    const decimals = amount % 1;
    if (decimals > 0) amount = amount - decimals + 1;
    return amount;
}

export function totalWithFees(amount, percentageFee, fixedFee) {
    return (amount + fixedFee) / (1 - percentageFee / 100);
}

export function feeQuote(amount, perso = true, minimum = 0) {
    const initial = parseFloat(amount);
    const total = totalWithFees(initial, perso ? 1.5 : 2.5, 0.25);
    const rawFees = total - initial;
    return {total, rawFees, fees: Math.round(rawFees * 100) / 100, offered: rawFees >= minimum};
}

export function acceptsFeeSuggestion(config) {
    // SEPA XML collections do not use the card-processing fee estimate.
    if (config?.platform === 'SEPA_XML') return false;
    // Stock checkouts freeze the exact reserved price; adding fees would change
    // that contract. Keep the organisation's preference for all other payments.
    return !(config?.type === 'CAMPAGNE' && config?.campagne?.lockId);
}

export function campaignFeeOffer(config, donation, monthlyDisplay, minimum) {
    if (!(minimum > 0) || !acceptsFeeSuggestion(config)) return null;
    // The existing form adds fees before division when the entered amount is
    // the total; a form already displaying an instalment adds them to that debit.
    const divideTotal = !donation.monthly && donation.months > 1 && !monthlyDisplay;
    const amount = divideTotal ? donation.amount : config.montant;
    const quote = feeQuote(amount, config.facturation?.perso !== false, minimum);
    if (!quote.offered) return null;
    const adjusted = Number(amount) + quote.fees;
    return {config, amount, fees:quote.fees, acceptedConfig:{...config,
        montant:divideTotal ? installmentAmount(adjusted, donation.months) : adjusted}};
}

// Deliberately retain main's current field consumption until the separate fix
// documented in docs/campaigns/main-fee-suggestion-bug.md is approved.
export function legacyFormFeeQuote(values, minimum) {
    return feeQuote(parseFloat(values.montant), !!values?.facturation?.perso, minimum);
}
